import React from 'react';
import './LandscapingDesign.css';

const Landscapingdesign = () => {
 
  const backgroundUrl = `${process.env.PUBLIC_URL}/design.jpeg`;

  return (
    <section
      className="Landscaping-design"
      style={{ backgroundImage: `url(${backgroundUrl})` }}
    >
      <div className="Landscaping-design__overlay">
        <h1 className="Landscaping-design__title">Landscape Design</h1>
      </div>
    </section>
  );
};

export default Landscapingdesign;